module.exports = __webpack_public_path__ + "img/hospitium-12.328a3900.jpg";